<app-reset-password
*ngIf="!hospitalURL && !schoolURL && !societyURL && !crmURL">
</app-reset-password>

<app-hospital-reset-password *ngIf="hospitalURL">
</app-hospital-reset-password>

<app-school-reset-password *ngIf="schoolURL">
</app-school-reset-password>

<app-society-reset-password *ngIf="societyURL"></app-society-reset-password>

<app-crm-reset-password *ngIf="crmURL"></app-crm-reset-password>
